<template>
    <div class="leftmenu">
        <div class="leftmenu-logo"></div>
        <div class="leftmenu-item" @click="$router.push('/companies')">Компании</div>
        <div class="leftmenu-item item-users" @click="$router.push('/users')">Пользователи</div>
        <div class="leftmenu-item item-kcop" @click="$router.push('/kcop')">Заявки КЦОП</div>
        <div v-show="permissions.left_menu_experts" class="leftmenu-item item-expert" @click="$router.push('/expertsgroup')">Эксперты оценки</div>
        <div v-show="permissions.left_menu_experts" class="leftmenu-item item-kcop" @click="$router.push('/kcop_criteria')">Критерии оценки КЦОП</div>
        <div v-show="permissions.left_menu_experts" class="leftmenu-item item-kcop" @click="$router.push('/kcop_resaults')">Результаты</div>
    </div>
</template>

<script>

export default {
    name: 'Leftmenu',
    data() {
        return {
            permissions: {}
        }
    },
    created() {
        this.permissions =  JSON.parse(localStorage.getItem('permissions'))   
    }
}

</script>

<style scoped>
    .leftmenu {
        display: block;
        position: fixed;
        width: 95px;
        height: calc(100%) !important;
        background: #103677;
    }
    .leftmenu-logo {
        display: block;
        width: 47px;
        height: 40px;
        background: url(../assets/img/ws-short.png) no-repeat;
        margin-left: 20px;
        margin-top: 20px;
    }
    .leftmenu-item {
        display: block;
        width: 90px;
        height: auto;
        background: url(../assets/img/item_menu.png) no-repeat;
        background-position-x: 30px;
        box-sizing: border-box;
        padding-top: 45px;
        color: #ffffff;
        font-size: 12px;
        text-align: center;
        cursor: pointer;    
        margin-top: 50px;
    }
    .leftmenu-item:hover {
        text-decoration: underline;
    }
    .item-users {
        background: url(../assets/img/item_menu_users.png) no-repeat;
        background-position-x: 30px;
        margin-top: 30px;
    }
    .item-kcop {
        background: url(../assets/img/item_menu_kcop_req.png) no-repeat;
        background-position-x: 30px;
        margin-top: 30px;
    }
    .item-expert {
        background: url(../assets/img/experts-white-icon.png) no-repeat;
        background-position-x: 30px;
        margin-top: 30px;
    }
</style>